import { cn } from '@/utils/common'
import React, { AllHTMLAttributes } from 'react'
import {
  Controller,
  FieldValues,
  RegisterOptions,
  Path,
  Control,
  FormState,
} from 'react-hook-form'
import Typography from './Typography'
import RenderIf from './RenderIf'

const Input = <T extends FieldValues>({
  name,
  validation,
  control,
  formState,
  className,
  placeholder,
  type,
  noError,
  ...props
}: AllHTMLAttributes<HTMLInputElement> & {
  name: Path<T>
  validation?: Omit<
    RegisterOptions<T, Path<T>>,
    'setValueAs' | 'disabled' | 'valueAsNumber' | 'valueAsDate'
  >
  control: Control<T, any>
  formState: FormState<T>
  noError?: boolean
}) => {
  return (
    <div className='w-full'>
      <Controller
        control={control}
        name={name}
        rules={validation}
        render={({ field }) => {
          return (
            <input
              type={type}
              placeholder={placeholder}
              className={cn(
                'shadow-1 text-secondary-content h-12 w-full rounded-xl bg-onSecondary-1 p-2 text-xs placeholder:text-xs placeholder:text-onSecondary-4 dark:placeholder:text-black',
                {
                  'border border-red': !!formState.errors[name],
                },
                className
              )}
              {...field}
              {...props}
            />
          )
        }}
      />
      <RenderIf isTrue={!noError && !!formState.errors[name]}>
        <Typography variant='subTitle' className='mr-2 text-red'>
          {!!formState.errors[name] &&
            ((formState.errors[name]?.message ||
              `${placeholder || ''}  اشتباه!`) as any)}
        </Typography>
      </RenderIf>
    </div>
  )
}

export default Input
